import { useState } from "react";
import { X } from "@phosphor-icons/react";
import CallbackSuggestion from "./CallbackSuggestion";

// VAGUE 44 — mode Simple : choix du créneau de rappel avant de passer au prospect suivant.
export default function CallbackPickModal({ biz, onPick, onClose }) {
  const [other, setOther] = useState("");
  const [availability, setAvailability] = useState(biz.call?.callback_reason || "");
  return (
    <div className="fixed inset-0 z-[90] bg-foreground/60 backdrop-blur-sm flex items-end sm:items-center justify-center p-3"
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }} data-testid={`callback-pick-modal-${biz.id}`}>
      <div className="bg-card border border-border rounded-sm shadow-xl w-full max-w-sm p-4 space-y-3">
        <div className="flex items-start justify-between gap-2">
          <div className="min-w-0">
            <div className="text-[10px] uppercase tracking-widest font-bold text-muted-foreground">Programmer le rappel</div>
            <div className="font-display font-semibold text-sm truncate">{biz.name}</div>
          </div>
          <button type="button" onClick={onClose} className="p-1 text-muted-foreground hover:text-foreground" aria-label="Fermer" data-testid="callback-pick-close"><X size={16}/></button>
        </div>
        <input value={availability} onChange={(e) => setAvailability(e.target.value)} maxLength={280}
          placeholder="Disponibilité donnée (ex : mardi après-midi)"
          className="w-full text-sm border border-border rounded-sm px-2.5 py-2 bg-background focus:border-primary outline-none" data-testid="callback-pick-availability"/>
        <CallbackSuggestion biz={biz} availability={availability}
          onApply={(at) => onPick({ status: "callback", callback_at: at, callback_reason: availability.trim() || undefined })}/>
        <label className="block text-xs">
          <span className="block text-[10px] uppercase tracking-widest font-bold text-muted-foreground mb-1">Ou un autre horaire</span>
          <input type="datetime-local" value={other} onChange={(e) => setOther(e.target.value)}
            className="w-full text-sm border border-border rounded-sm px-2.5 py-2 bg-background" data-testid="callback-pick-other"/>
        </label>
        <div className="flex gap-2 justify-end">
          <button type="button" onClick={() => onPick({ status: "callback", callback_at: null, callback_reason: availability.trim() || undefined })}
            className="text-xs font-semibold border border-border rounded-sm px-3 py-2" data-testid="callback-pick-no-time">Sans heure précise</button>
          <button type="button" disabled={!other}
            onClick={() => onPick({ status: "callback", callback_at: new Date(other).toISOString(), callback_reason: availability.trim() || undefined })}
            className="text-xs font-bold bg-[#C8795A] text-white rounded-sm px-3 py-2 disabled:opacity-50" data-testid="callback-pick-save-other">Valider cet horaire</button>
        </div>
      </div>
    </div>
  );
}
